import { Component } from '@angular/core'
import { LanguageSwitcherWidget, ThemeSwitcherWidget } from '@corporate-tailwind/widget'
import { TranslateModule } from '@ngx-translate/core'

@Component({
    selector: 'app-page-401',
    imports: [/*LanguageSwitcherWidget, ThemeSwitcherWidget,*/ TranslateModule],
    templateUrl: './page-401.component.html',
    styleUrl: './page-401.component.scss'
})
export class Page401Component {

}
